module.exports = __webpack_public_path__ + "img/402.1e5695e8.jpg";